






























































































import Vue from "vue";
import ApiSearchPage from "@/components/apiSearch/components/ApiSearchPage.vue";
import { ApiSearchColumn, ColumnType } from "@/components/apiSearch/models/ApiSearch";
import DateInput from "@/components/DateInput.vue";
import MoneyInput from "@/components/MoneyInput.vue";
import IconButton from "@/components/IconButton.vue";
import base64toUInt8Array, { openPdfInNewTab } from "@/utils/fileConvert";
import dayjs from "dayjs";
import CardPaymentApi from "./services/CardPaymentsApi";
import { t } from "@/plugins/i18n";

interface CardPaymentRow {
    viro: number;
    partner: string;
    amount: number;
    currency: string;
    paymentDate: string;
    bankAccountNo: string;
    details?: boolean;
    newShipDate?: string;
    newAmount?: number;
    saving?: boolean;
    printing?: boolean;
}

export default Vue.extend({
    components: {
        ApiSearchPage,
        DateInput,
        MoneyInput,
        IconButton
    },

    data() {
        return {
            isExcelExport: false,
            reportDate: dayjs(new Date()).format("YYYY-MM-DD"),
        }
    },

    methods: {
        async getExcel() {
            const excel = await CardPaymentApi.getExcel(this.reportDate);

            const linkSource = `data:application/vnd.openxmlformats;base64,${excel}`;
              const downloadLink = document.createElement("a");
              const fileName =
                "BANKKARTYAFIZ_" +
                dayjs(this.reportDate).format("YYYY-MM-DD") +
                ".xlsx";
              downloadLink.href = linkSource;
              downloadLink.download = fileName;
              downloadLink.click();
        },

        toggleEdit(item: CardPaymentRow) {
            if (!item.details) {
                this.$set(item, "newShipDate", dayjs(item.paymentDate).format("YYYY-MM-DD"));
                this.$set(item, "newAmount", item.amount);
                this.$set(item, "saving", false);
            }
            item.details = !item.details;
        },

        async saveChange(item: CardPaymentRow) {
            this.$set(item, "saving", true);
            try {
                await CardPaymentApi.changeVirtualPayment(
                    item.viro,
                    item.newShipDate ?? null,
                    item.newAmount ?? null
                );
                item.details = false;
                (this.$refs.asref as any)?.refreshClick();
            } finally {
                this.$set(item, "saving", false);
            }
        },

        async printViro(item: CardPaymentRow) {
            this.$set(item, "printing", true);
            try {
                const pdfs = await CardPaymentApi.printViro(item.viro);
                pdfs.forEach((pdf) => openPdfInNewTab(base64toUInt8Array(pdf)));
            } finally {
                this.$set(item, "printing", false);
            }
        }
    },

    computed: {
        columns: (): ApiSearchColumn[] => [
        {
            title: t("Partner"),
            field: "partner",
        },
        {
            title: t("EredetiPartner"),
            field: "originalPartner",
            filterable: true,
        },
        {
            title: t("GeneralOutgoingInvoice_SzamlaSorszama"),
            field: "invoiceNo",
            filterable: true,
        },
        {
            title: t("Telephely"),
            field: "depotName",
            filterable: true,
        },
        {
            cell: "amount",
            field: "amount",
            title: t("Osszeg"),
            type: ColumnType.Money,
        },
        {
            title: t("Datum"),
            field: "paymentDate",
            type: ColumnType.Date,
            range: true,
            filterable: true

        },
        {
            title: t("Bankszamlaszam"),
            field: "bankAccountNo",
        },
        {
            cell: "actions",
            filterable: false,
        },
        ],

        url() {
            return 'bankout/card-payments';
        }
    },
})
